module.exports = __webpack_public_path__ + "static/media/zs-antoninska.44e1decd.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/zs-antoninska.png
// module id = 448
// module chunks = 0